(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/wager-payment-flow/marketplace-flow/assets/javascripts/marketplace-payment-flow.js') >= 0) return;  svs.modules.push('/components/wager-payment-flow/marketplace-flow/assets/javascripts/marketplace-payment-flow.js');
"use strict";


const createPayment = svs.components.payment.payment.createPayment;
const grassroots = svs.components.payment.middleware.grassroots;
const authenticated = svs.components.payment.middleware.authenticated.authenticated;
const _svs$components$wager = svs.components.wagerPaymentFlow.marketplaceFlow.middlewareSetup,
  marketplaceSharesMW = _svs$components$wager.marketplaceSharesMW,
  paymentConfirmMW = _svs$components$wager.paymentConfirmMW,
  marketplaceBalanceMW = _svs$components$wager.marketplaceBalanceMW,
  paymentDoneMW = _svs$components$wager.paymentDoneMW;
const WagerService = svs.components.payment.serviceWager.WagerService;

const createMarketplacePaymentFlow = _ref => {
  let config = _ref.config,
    wagers = _ref.wagers,
    _ref$isC2C = _ref.isC2C,
    isC2C = _ref$isC2C === void 0 ? false : _ref$isC2C;
  const paymentBuilder = createPayment(new WagerService(config)).addPayable(...wagers).addPreMiddleware(authenticated).addPreMiddleware(marketplaceSharesMW).addPreMiddleware(marketplaceBalanceMW).addPreMiddleware(paymentConfirmMW).addPostMiddleware(paymentDoneMW);
  if (isC2C) {
    paymentBuilder.addPostMiddleware(grassroots);
  }
  return paymentBuilder;
};
setGlobal('svs.components.wagerPaymentFlow.marketplaceFlow.createMarketplacePaymentFlow', createMarketplacePaymentFlow);

 })(window);